import { parse } from 'graphql';
export function parseSelectionSet(selectionSet) {
    const query = parse(selectionSet).definitions[0];
    return query.selectionSet;
}
//# sourceMappingURL=selectionSets.js.map